import countryList from 'react-select-country-list';

export const countryCodeData = countryList().getData()
export const countryCodeMap = countryList().getData().reduce((acc, country) => {
    acc[country.label] = country.value;
    return acc;
}, {});

export const getCountryName = (portCode) =>{
    //console.log("getCountryName is executing-------",portCode)
    const countryCode = portCode?.substring(0,2)
    const country = countryCodeData.find(country => country.value === countryCode);
    // console.log("---country---",country)
    return (country.label ? country.label : null);
}